import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { APP_Constants } from '../app.constant';
import { AppService } from '../app.service';
import { Modal } from '../common/modal/modal';
import { ModalService } from '../common/modal/modal.service';

import { DhlFormControlEventData } from '../common/models/dhl-form-control-event-data';
import { CustomSnackBarService } from '../common/snack-bar/snack-bar.service';


@Component({
    selector: 'app-training-document-upload',
    templateUrl: './training-document-upload.component.html',
    styleUrls: ['./training-document-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TrainingDocumentUploadComponent implements OnInit {
  trainingDoc: Object;
  customerCode: string;
  uploadOrderTemplate: any;
  formData: any;
  frmGroup;
  customerList
  flag: boolean;
  commonSubject: any;
  postData: FormData;
  finalTemp1: string | Blob;
  isLoading: boolean;
  selectedValues: any;
  fileData: any;
  durationInSeconds: number=20;
  errorMsg: Object;

  normalView() {
    document.getElementById("overlay").style.display = "none";
  }

  constructor(private appService: AppService, private _snackBar: CustomSnackBarService, private modalService: ModalService, private http: HttpClient) { }

  ngOnInit(): void {
    this.appService.makeHttpGetRequest(APP_Constants.VALIDATE_SCHEMA +
      localStorage.getItem('userName') + '&action=TRAINING_DOCUMENT').subscribe(
        (res : any) => {
          this.uploadOrderTemplate=res.data.template;
        })
   }

  submitUploadOrderDetails(data) {
    this.selectedValues = data.postData.param;
    this.flag = false;    
    this.fileData = this.appService.getUploadFileData();
    const formData: FormData = new FormData();
    if (this.fileData){
      formData.append('file', this.fileData, this.fileData.name);
    this.postData = formData;
    this.isLoading = true;
    document.getElementById("overlay").style.display = "block";
      const uploadDocURL = this.uploadDocumentGenerateURL(APP_Constants.TRAINING_DOC_UPLOAD, this.fileData.name,this.selectedValues.userRole,this.selectedValues.documentType,this.selectedValues.customerCode);
      let authToken1 = localStorage.getItem('authToken');
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken1 });
      this.http.post(environment.apiUrl + uploadDocURL, this.postData, { headers, responseType: 'text' }).subscribe((response: string) => {
        this.normalView();
        let parsedMsg: string;
        try {
          const parsed = JSON.parse(response);
          parsedMsg = parsed?.message?.statusMessage || parsed?.message || parsed?.statusMessage || response;
        } catch {
          parsedMsg = response;
        }
        if (parsedMsg && parsedMsg.toLowerCase().includes('already')) {
          let modal = new Modal({ action: false, name: 'download', title: 'Upload File', actionButtonText: '', description: parsedMsg });
          this.modalService.createModalBox(modal, 400);
        } else {
          this._snackBar.open({ message: 'Document uploaded successfully' }, { duration: this.durationInSeconds * 100 });
          location.reload();
        }
      }, (err) => {
        this.normalView();
        let description: string;
        try {
          const parsed = JSON.parse(err?.error);
          description = parsed?.message?.statusMessage || parsed?.message || parsed?.statusMessage || err?.message || 'An error occurred';
        } catch {
          description = err?.error || err?.message || 'An error occurred';
        }
        let modal = new Modal({ action: false, name: 'download', title: 'Upload File', actionButtonText: '', description });
        this.modalService.createModalBox(modal, 400);      
      });
  } 
  }

  // https://dsctopdev.dhl.com/docsservice/documentUpload?
  // customerCode=TMSLITE-TEST&userId=Gauri.Dharm@dhl.com&
  // fileName=Ascencia_Data Upload_Gauri.Dharm_12_22_2022-11_01_11 AM.csv&
  // role=Planner&
  // documentType=Training Document

  uploadDocumentGenerateURL(uploadURL: string,filename:string,userRole:string,documentType:string,customerCode:string): string {
    let params = {
      customerCode:customerCode,
      userId: localStorage.getItem('userName'),
      fileName:filename,
      role: userRole,
      documentType:documentType
    }
    let queryParams = new HttpParams({ fromObject: params });
    return uploadURL + '?' + queryParams.toString() + '&action=UPLOAD_DOC';
  }

  LoadCustomerDropdownOptions(event: DhlFormControlEventData) {
    event.component.listOptions = this.customerList;
  }


  onCustomerCodeChange(event: DhlFormControlEventData) {
    let selectedOpt = this.customerList.filter((option) => {
      if (option.value == event.data.value) {
        return true;
      }
    })[0];
    event.component.frmGroup.get("userRole").setValue("");
    event.component.frmGroup.markAsUntouched();
    event.eventData.eventConfig.affectedColumns.forEach(element => {
      let elementValue;
      if(element.multipleValue){
        elementValue = element.multipleValue;
      } else {
        elementValue = element.value;
      }
      elementValue.forEach(component => {
        let fieldName = (typeof component == 'object' ? component.name : component);
        let comp = this.appService._components[component.name];
        if (!comp.configData.editable && fieldName != 'parameterId') {//
          comp.frmGroup.get(component.name).enable();
        }
        comp.dropDownListItems = selectedOpt.customerRole;
        comp.allowSecondaryRoles = selectedOpt.allowSecondaryRoles;
        comp.frmGroup.allowSecondaryRoles = selectedOpt.allowSecondaryRoles;
      });
    });
    if (event.component.frmGroup.get('dataRestrictions')) {
      delete event.component.frmGroup.controls.dataRestrictions;
    }
    if (!event.component.frmGroup.allowSecondaryRoles) {
      let seccomp = this.appService._components["secondaryUserRoles"];
      seccomp.configData.hidden = true;
      seccomp.hidden = true;
      seccomp.frmGroup.get('secondaryUserRoles').hidden = true;
      document.getElementById("secondaryUserRoles").style.visibility = "hidden";
      document.getElementById("secondaryUserRoles").style.display = "none";
    }

    // this.superUserTemplate.data.template.controls[0].actions[0].command.groups[1].controls = this.superUserTemplate.data.template.controls[0].actions[0].command.groups[1].controls.filter((item) => item.name != "dataRestrictions")
  }
  
  ngAfterViewInit() {
    this.commonSubject = this.appService._commonComponentSubject.subscribe(res => {
      if (res) {
        if (res.name === this.uploadOrderTemplate.name && res.action === 'SUBMIT' && res.configData) {
          this.submitUploadOrderDetails(res);
        }else if (res.action == 'LOAD_CUSTOMERS_OPTIONS') {
            this.LoadCustomerDropdownOptions(res);
          } else if (res.action == 'CHANGE_CUSTOMERS_OPTION') {
            this.onCustomerCodeChange(res);
          }
      }
    })
  }
}
